import React from "react";

const LoadingIndicator: React.FC<Record<string, unknown>> = () => (
  <div className="flex flex-1 justify-center items-center p-8">
    <img src="images/loading.gif" width="140" height="140" alt="Loading&hellip;" />
  </div>
);

export default LoadingIndicator;
